import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import { AppConfig } from '../utils/app-config';

@Injectable({
  providedIn: 'root'
})
export class CompanyAdminService {
  private baseUrl = AppConfig.getConfig().api_url;
  constructor(private httpClient: HttpClient) {
  }

  getCompanyDashData(){
    return this.httpClient.get(`${this.baseUrl}company/dashboard/`).pipe(
      tap((response: any) => response)
    )
  }

  getEmployeesList(){
    return this.httpClient.get(`${this.baseUrl}report/company/employee`).pipe(
      tap((response: any) => response)
    )
  }

  getReportList(sDate:any,eDate:any,id:any,page:any){
    return this.httpClient.get(`${this.baseUrl}company/posts/reports/?start_date=${sDate}&end_date=${eDate}&id=${id}&page=${page}`).pipe(
      tap((response: any) => response)
    )
  }

  getFbReportList(sDate:any,eDate:any,id:any,page:any){
    return this.httpClient.get(`${this.baseUrl}user/${id}/facebook/report/?start_date=${sDate}&end_date=${eDate}&page=${page}`).pipe(
      tap((response: any) => response)
    )
  }  
  // exportReportList(sDate:any,eDate:any,id:any,page:any){
  //   return this.httpClient.get(`${this.baseUrl}user/${id}/facebook/report/export/?start_date=${sDate}&end_date=${eDate}`).pipe(
  //     tap((response: any) => response)
  //   )
  // }

  exportReportList(sDate:any,eDate:any,id:any,page:any){
    return this.httpClient.get(`${this.baseUrl}user/${id}/facebook/report/export/?start_date=${sDate}&end_date=${eDate}`);
  }

  getInstagramReportList(sDate:any,eDate:any,id:any,page:any){
    return this.httpClient.get(`${this.baseUrl}user/${id}/instagram/report/?start_date=${sDate}&end_date=${eDate}&page=${page}`).pipe(
      tap((response: any) => response)
    )
  }

  getTwitterReportList(sDate:any,eDate:any,id:any,page:any){
    return this.httpClient.get(`${this.baseUrl}user/${id}/twitter/report/?start_date=${sDate}&end_date=${eDate}&page=${page}`).pipe(
      tap((response: any) => response)
    )
  }

  getSamlSettings(){
    return this.httpClient.get(`${this.baseUrl}company/saml/setting/`).pipe(
      tap((response: any) => response)
    )
  } 
  editSamlSettings(body: any) {
    return this.httpClient.put(`${this.baseUrl}company/saml/setting/`, body).pipe(
      tap((response: any) => response)
    );
  }
}
